import { Box, Button, Dialog, IconButton, InputBase, Paper, Skeleton, Stack, Typography } from "@mui/material";
import styled from "styled-components";


export const TypoRepro = styled(Typography)({
    fontFamily: "'Repro', sans-serif"
});

export const VipUploadNote = styled(Typography)({
    fontFamily: "'Repro', sans-serif",
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    paddingTop: '8px',
    paddingBottom: '30px',
});

export const TypoReproMono = styled(Typography)({
    fontFamily: "'Repro Mono', sans-serif"
});

export const Chat = styled(Box)<{ $isVipPage?: boolean }>(({ $isVipPage }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: $isVipPage ? '40px' : '0',
    boxShadow: $isVipPage ? '0 4px 14px rgba(0,0,0,.05)' : 'none',
    marginBottom: $isVipPage ? '12px' : '0',

    ...($isVipPage && {
        borderRadius: '0 0 16px 16px',
        minHeight: '300px',
        height: 'calc(100% - 94px)',
    })
}));

export const HeaderChat = styled(Box)({
    padding: '16px 24px',
    backgroundColor: '#F4F2F0',
    '@media (max-width: 460px)': {
        padding: '16px 12px',
    }
});

export const HeaderChatMessage = styled(Box)({
    backgroundColor: '#FCFAFA',
    borderRadius: '16px',
    padding: '20px 16px'
});

export const ChatVIPHeader = styled(Box)<{ $isVipPage?: boolean }>(({ $isVipPage }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 25px',
    borderBottom: '1px solid #E8E5E3',
    backgroundColor: '#fff',
    borderTopLeftRadius: $isVipPage ? '16px' : '0',
    borderTopRightRadius: $isVipPage ? '16px' : '0',
    ...($isVipPage && {
        border: '1px solid #e6e6e6 !important',
    }),

    '@media (max-width: 768px)': {
        padding: '12px 15px',
    }
}));

export const CoachAvatar = styled.img({
    width: '75px',
    height: '75px',
    borderRadius: '50%',
    objectFit: 'cover',
    flexShrink: 0,
    '@media (max-width: 768px)': {
        width: '40px',
        height: '40px',
    },
});

export const CoachHeaderInfo = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: 0,
});

export const CoachHeaderText = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0,
});

export const CoachName = styled.span({
    fontFamily: "'Roboto', sans-serif",
    fontSize: '22px',
    fontWeight: 500,
    lineHeight: 1,
    color: '#1D1A1A',
});

export const CoachDescription = styled.span({
    fontFamily: "'Repro', sans-serif",
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.4',
    color: '#7B726C',
    '@media (max-width: 768px)': {
        display: 'none',
    },
});

export const InactiveChannelBanner = styled.div`
    color: #fd3300;
    padding: 12px 20px;
    font-size: 16px;
    font-family: Repro, sans-serif;
    line-height: 1.4;
    border: 1px solid rgb(230, 230, 230);
    border-top: none;
`;

export const BodyChat = styled(Box)<{ $isVipPage?: boolean }>(({ $isVipPage }) => ({
    display: 'flex',
    flexDirection: 'column-reverse',
    height: '578px',
    backgroundColor: $isVipPage ? 'white' : '#F8F8F8',
    padding: '24px',
    overflowY: 'auto',

    ...($isVipPage && {
        border: '1px solid #e6e6e6 !important',
        borderTop: 'none !important',
        borderBottom: 'none !important',
        flexGrow: 1,
    }),
}));

export const HeaderChatMessageUploadBox = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '18px',
    '@media (max-width: 620px)': {
        flexDirection: 'column',
        gap: '12px',
        marginBottom: '16px',
    }
})

export const TypoHeaderInisideTitle = styled(TypoRepro)({
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '103%',
    letterSpacing: '-0.3%',
    color: '#131214',
    textTransform: 'uppercase',
    marginBottom: '4px'
});

export const TypoHeaderCInsideSubTitle = styled(TypoRepro)({
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '1.22',
    letterSpacing: '-1%',
    color: '#898D8F',
    textTransform: 'capitalize'
});

export const BtnUploadSwing = styled(Button)({
    fontFamily: "'Repro', sans-serif",
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '0.87',
    letterSpacing: '-3%',
    textTransform: 'capitalize',
    backgroundColor: '#FD3300',
    color: 'white',
    padding: '15px 21px',
    borderRadius: '100px',
    '& span': {
        marginRight: '12px'
    },
    '&:hover': {
        backgroundColor: '#DB2C00'
    },
    '@media (min-width: 620px) and (max-width: 768px)': {
        width: '294px',
    },
    '@media (max-width: 620px)': {
        width: '100%',
        '& span': {
            marginRight: '15px'
        },
    }
});

export const HeaderInideMessage = styled(TypoReproMono)({
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '135%',
    textTransform: 'uppercase',
    color: '#6E7375',
    '& span': {
        color: '#1D1A1A',  // or whatever color you want
    },
    '@media (max-width: 768px)': {
        fontSize: '12px',
    }
});

export const MessageBox = styled(Box)<{ $own?: boolean, $isVipPage?: boolean }>(({ $own, $isVipPage }) => ({
    fontFamily: "'Lato', sans-serif",
    display: 'flex',
    width: '100%',
    flexDirection: $own ? 'row-reverse' : 'row',
    alignItems: 'center',
    alignSelf: $own ? 'flex-end' : 'flex-start',
    justifyContent: $isVipPage? 'unset' : 'space-between',
    marginBottom: '12px',
    '&:first-child': {
        marginBottom: '0'
    },
    '@media (max-width: 460px)': {
        ...(!$isVipPage && {
            flexDirection: 'column-reverse',
            alignItems: $own ? 'end' : 'start',
        }),
    }
}));

export const Message = styled(Box)<{ $own?: boolean, $isVipPage?: boolean }>(({ $own, $isVipPage }) => ({
    padding: '12px 15px',
    borderRadius: '9px',
    backgroundColor: $own ? '#7B726C' : '#F3F4F7',
    color: $own ? '#FFFFFF' : '#1D1A1A',
    maxWidth: $isVipPage ? '535px' : '233px',
    minWidth: 0,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '16px',
    cursor: 'pointer',
    position: 'relative',
    ...$own && {
        [`&:hover ${MessageOption}`]: {
            display: 'block',
            position: 'absolute',
            top: '2px',
            right: '-3px',
            cursor: 'pointer',
        }
    },
    '@media (max-width: 460px)': {
        maxWidth: '100%',
    },

    ...($isVipPage && $own && {
        marginLeft: '14px',
    }),
    ...($isVipPage && !$own && {
        marginRight: '14px',
    })
}));

export const DateSeparator = styled.div({
    fontFamily: "'Repro', sans-serif",
    display: 'flex',
    justifyContent: 'center',
    fontSize: '14px',
    lineHeight: '1',
    color: 'rgb(161, 160, 160)',
    margin: '8px 0',
    textAlign: 'center',
});

export const MessageEmbed = styled.div<{ $own?: boolean }>(({ $own }) => ({
    width: '100%',
    maxWidth: '360px',
    marginBottom: '12px',
    alignSelf: $own ? 'flex-end' : 'flex-start',
    '& iframe': {
        width: '100%',
        height: '200px',
        display: 'block',
        border: 'none',
        borderRadius: '9px',
    },
}));

export const MessageDate = styled.span({
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '21px',
    color: '#868585',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    fontFamily: "'Repro', sans-serif",
});

export const ChatFooter = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '# fcfafa',
    gap: '14px',
    '@media (max-width: 460px)': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
    }
});

export const UploadSwingAction = styled(Box)({
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
});

export const UploadSwingMessage = styled(Box)({
    
});

export const UploadSwingTypo = styled(TypoRepro)({
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '122%',
    letterSpacing: '-1%',
    textTransform: 'capitalize',
    color: '#FD3300'
});

export const UploadSwingMessageTypo = styled(TypoRepro)({
    fontSize: '14px',
    lineHeight: '122%',
    letterSpacing: '-1%',
    fontWeight: 400,
    color: '#7B726C',
    '@media (max-width: 768px)': {
        fontSize: '12px',
    },
    '@media (max-width: 460px)': {
        padding: '12px',
        paddingTop: '0',
    }
});

export const InputBox = styled(Paper)<{ $isVipPage?: boolean }>(({ $isVipPage }) => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    backgroundColor: '#FFFFFF',
    borderRadius: '0 0 16px 16px',
    borderBottom: '1px solid #ECE9E4',
    '@media (max-width: 460px)': {
        paddingRight: $isVipPage ? '0' : '10px',
    },
    ...($isVipPage && {
        borderTop: '1px solid hsla(0,0%,86%,.45)',
    }),
}));

export const VipUploadButton = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '18px 16px',
    paddingLeft: '30px',
    cursor: 'pointer',
    flexShrink: 0,
    userSelect: 'none',
    '& img': {
        width: '24px',
        height: '24px',
        display: 'block',
    },
    '@media (max-width: 768px)': {
        flex: '0 0 100%',
        width: '100%',
        boxSizing: 'border-box',
        borderRight: 'none',
        padding: '14px 16px',
        backgroundColor: '#F4F2F0',
    },
});

export const VipUploadButtonText = styled.span({
    fontFamily: "'Repro', sans-serif",
    fontSize: '16px',
    fontWeight: 400,
    color: '#1D1A1A',
    whiteSpace: 'nowrap',
});

export const Input = styled(InputBase)({
    marginLeft: '1',
    flex: '1',
    padding: '0 16px',
    '& input': {
        padding: 0
    },
    '@media (max-width: 460px)': {
        '& input': {
            padding: '14px 0'
        },
    }
});

export const MessageOption = styled.span({
    display: 'none',
});

export const VideoMessage = styled(Box)<{ thumbnail?: string, $own?: boolean, $isVipPage?: boolean }>(({ thumbnail, $own, $isVipPage }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '200px',
    height: '200px',
    borderRadius: '9px',
    backgroundImage: `url(${thumbnail})` || 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: $own ? '#7B726C' : '#F3F4F7',
    padding: '0',
    position: 'relative',

    ...($isVipPage && $own && {
        marginLeft: '14px',
    }),

    ...($isVipPage && !$own && {
        marginRight: '14px',
    }),

    '& svg': {
        cursor: 'pointer',
    },
    ...$own && {
        [`&:hover ${MessageOption}`]: {
            display: 'block',
            position: 'absolute',
            top: '3px',
            right: '-4px',
            cursor: 'pointer',
        }
    },
}));

export const SendbirdVideoModal = styled(Dialog)({
    '& .MuiDialog-paper': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        maxWidth: '680px',
        width: '680px',
        '@media (max-width: 768px)': {
            maxWidth: '100%',
            width: '100%',
        }
    }
});

export const CloseIconButton = styled('button')({
    position: 'absolute',
    right: '30px',
    top: '14px',
    height: '15px',
    width: '15px',
    padding: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    '& img': {
        width: '100%',
        height: '100%',
    }
});

export const PlayVideoBox = styled(Box)({
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '60px',
    '& iframe': {
        width: '100%',
        height: '315px',
        display: 'block',
    },
    '& video': {
        width: 'calc(100% - 50px)',
        height: 'auto',
        display: 'block',

        '@media (max-width: 768px)': {
            width: 'calc(100% - 30px)',
        }
    }
});

export const CloseVideoButton = styled(Button)({
    fontFamily: "'Repro', sans-serif",
    width: 'calc(100% - 50px)',
    color: 'white',
    backgroundColor: '#fd3300',
    borderRadius: '50rem',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'capitalize',
    margin: '20px 25px 30px',
    '&:hover': {
        backgroundColor: '#db2c00'
    }
});

export const UploadFile = styled(Box)({
    fontFamily: "'Repro', sans-serif",
    fontWeight: '400',
    fontSize: '15px',
    '& span: last-child': {
        margin: '0 10px',
        color: '#2a48b1',
        cursor: 'pointer'
    }
});

export const UploadFileCheckIcon = styled('i')({
    color: '#fff',
    background: '#fd3300',
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '5px',
});

export const StackSkeleton = styled(Stack)({

});

export const ChatLoadSkeleton = styled(Box)<{ $isVipPage?: boolean }>(({ $isVipPage }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '578px',
    padding: '24px',
    gap: '12px',
    overflowY: 'scroll',
    backgroundColor: $isVipPage ? 'white' : '#F8F8F8',
}));

export const SkeletonLeftSide = styled(Box)({
    display: 'flex',
    width: '100%',
    gap: '12px',
    flexDirection: 'column'
});

export const SkeletonRightSide = styled(Box)({
    display: 'flex',
    width: '100%',
    gap: '12px',
    flexDirection: 'column',
    alignItems: 'end'
});

export const SkeletonMessage = styled(Skeleton)({
    width: '233px',
    height: '100px',
});

export const SubmitButton = styled(IconButton)<{ $isVipPage?: boolean }>(({ $isVipPage }) => ({
    height: '50px',

    '@media (min-width: 769px)': {
        paddingRight: $isVipPage ? '60px' : '12px',
    },
    ...($isVipPage && {
        '&:hover': {
            backgroundColor: 'transparent',
        }
    })
}));